// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__192q8","col":"styles_col__24cg5"};